export const COURSE_TYPE: Record<string, string> = {
  short: 'Short course',
  'masters-degree': 'Master’s Degree',
  postgraduate: 'Postgraduate',
  'bachelors-degree': 'Bachelor’s Degree',
  othm: 'OTHM',
} as const;
